import { SearchTable } from '@aibees/elephant/types';
import { SearchFilterBase } from '../types';
import company from './company';
import employees from './employees';
import people from './people';

export const filterConfigs: Record<SearchTable, SearchFilterBase[]> = {
  [SearchTable.Company]: company,
  [SearchTable.People]: people,
  [SearchTable.Employees]: employees,
  [SearchTable.BuyingTeam]: [],
  // [SearchTable.BuyingTeam]: buyingTeam,
};

// Dev-only invariant: a filter's id (or its name, when id is unset) is the
// persistence identity for pin/order presets. Two filters sharing an id in the
// same scope would silently corrupt each other's saved pin/order. Fail loud in
// dev so an accidental collision (e.g. a rename that reuses an old frozen id)
// is caught immediately. No-op in production builds.
if (import.meta.env.DEV) {
  Object.entries(filterConfigs).forEach(([scope, filters]) => {
    const seen = new Set<string>();
    filters.forEach((f) => {
      const id = f.id ?? f.name;
      if (seen.has(id))
        throw new Error(
          `[search-filters] Duplicate filter id "${id}" in scope "${scope}". ` +
            `Filter ids must be unique per scope — they key pin/order presets. ` +
            `If you renamed a filter, set its "id" to its ORIGINAL name (and only that filter's).`
        );
      seen.add(id);
    });
  });
}
